module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_sns_02-d598199e6ff80e7413e21f447bed32cf.jpg";